import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getTranslations } from '../Shared/translations';

interface ErrorsProps {
  visible: boolean;
  message: string;
  onDataChange: (visible: boolean) => void;
}

const Errors: React.FC<ErrorsProps> = ({ visible, message, onDataChange }) => {
  const t = getTranslations();

  const handleClose = () => {
    onDataChange(false);
  };

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>{t.error}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t.ok}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Errors;
